// extracted by mini-css-extract-plugin
export default {"root":"HeadlineWithButtons_root__iy9f1","head":"HeadlineWithButtons_head__b0pJw"};